<template>
  <I18nT
    keypath="agent.form.legal_mentions.body"
    class="whitespace-pre-line text-xs text-neutral-40"
    tag="p"
  >
    <template #privacy_policy>
      <NuxtLinkLocale
        to="privacy-policy"
        class="lowercase underline"
        :text="$t(`core.navigation.privacy_policy`)"
      />
    </template>
    <template #bloctel>
      <a
        href="http://www.bloctel.gouv.fr/"
        class="underline"
        target="_blank"
        v-text="$t(`agent.form.legal_mentions.bloctel`)"
      />
    </template>
  </I18nT>
</template>
